import { brainPicks } from "@/mocks/manga";
import MangaCard from "./MangaCard";

export default function BrainSection() {
  return (
    <section id="brain" className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-widest text-accent-400 mb-2">脑洞精选 · 设定炸裂</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
              脑洞大开的高概念之作
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm">
            天马行空的设定与惊人反转，读到最后一页才明白一切早有伏笔。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {brainPicks.map((manga) => (
            <MangaCard key={manga.id} manga={manga} compact />
          ))}
        </div>
      </div>
    </section>
  );
}